/**
 * AI实时纪要
 * @returns
 */
import { aiApi } from '../../request/index';
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';
class AiOutlineServer extends BaseServer {
  constructor() {
    super();
    if (typeof AiOutlineServer.instance === 'object') {
      return AiOutlineServer.instance;
    }
    this.state = {
      config: {}
    };
    AiOutlineServer.instance = this;
    this.listener();
    return this;
  }
  //获取总结列表
  getSummaryList = async (params) => {
    return await aiApi.getSummaryList(params);
  }
  //获取逐字列表
  getAsrList = async (params) => {
    return await aiApi.getAsrList(params);
  }
  getAsrSummaryList = async (params) => {
    return await aiApi.getAsrSummaryList(params);
  }
  sendAiqaAsk = async (params) => {
    return await aiApi.sendAiqaAsk(params);
  }
  getAiqaHistory = async (params) => {
    return await aiApi.reqAiqaHistory(params);
  }
  getAIConfig = async (params) => {
    const res = await aiApi.getAIConfig(params);
    if (res.code == 200) {
      this.state.config = res.data
    }
    return res
  }
  getAIMindMap = async (params) => {
    return await aiApi.getAIMindMap(params);
  }
  //获取ai思维导图数据
  getMindMap = async (params) => {
    return await aiApi.getMindMap(params);
  }
  listener = () => {
    useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      const { type = '' } = temp.data || {};

      switch (type) {
        // 计时器暂停
        case 'ai_asr_msg':
          this.$emit('ai_asr_msg', temp);
          break;

        case 'ai_summary_msg':
          this.$emit('ai_summary_msg', temp);
          break;
        case 'ai_mind_map_msg':
          this.$emit('ai_mind_map_msg', temp);
          break;
        case 'ai_barrage_msg':
          this.$emit('ai_barrage_msg', temp);
          break;
        default:
          break;
      }
    });
  }
}

export default function useAiOutlineServer() {
  return new AiOutlineServer();
}

// asr_end_time
// :
// "41940"
// asr_id
// :
// "12894593308_68ad149b9fe30266844847b0_1_105"
// asr_slice_type
// :
// 2
// asr_start_time
// :
// "31560"
// asr_text
// :
// "算了，你对现状的不满，然后焦虑的本质来源于你成长速度太慢，就是往往不开心的人更容易做出伟大的成就。"
// event_time
// :
// 1756173513
// type
// :
// "ai_asr_msg"